var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M18.08 21.856C16.8 22.432 15.232 22.88 13.376 22.88C11.232 22.88 9.56801 22.272 8.448 20.96C7.36 19.68 6.912 17.856 6.912 15.776C6.912 13.92 7.264 12.576 8.16001 11.68C9.024 10.816 10.336 10.4 12.448 10.4C14.24 10.4 16.064 10.688 17.824 11.168L18.304 6.144C16.896 5.248 14.784 4.416 12.352 4.416C9.024 4.416 6.144 5.632 4.096 7.872C2.176 9.984 0.992004 12.96 0.992004 16.704C0.992004 20.128 1.984 22.944 3.584 24.928C4.96 26.624 7.36 28.352 11.424 28.352C14.368 28.352 16.704 27.456 18.432 26.208L18.08 21.856Z",
  fill: "#0E1F25"
});
var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M18.08 21.856C16.8 22.432 15.232 22.88 13.376 22.88C11.232 22.88 9.56801 22.272 8.448 20.96C7.36 19.68 6.912 17.856 6.912 15.776C6.912 13.92 7.264 12.576 8.16001 11.68C9.024 10.816 10.336 10.4 12.448 10.4C14.24 10.4 16.064 10.688 17.824 11.168L18.304 6.144C16.896 5.248 14.784 4.416 12.352 4.416C9.024 4.416 6.144 5.632 4.096 7.872C2.176 9.984 0.992004 12.96 0.992004 16.704C0.992004 20.128 1.984 22.944 3.584 24.928C4.96 26.624 7.36 28.352 11.424 28.352C14.368 28.352 16.704 27.456 18.432 26.208L18.08 21.856Z",
  fill: "url(#paint0_linear_1624_10791)"
});
var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4448 28H27.0128L26.9168 21.28C26.8848 18.048 26.8208 14.528 26.6288 10.656H26.6928C27.6848 16.512 28.5488 20.896 30.4368 28H35.4608C37.3488 20.896 38.2768 16.512 39.3008 10.656H39.3648C39.1408 14.528 39.1088 17.984 39.0768 21.056L38.9808 28H44.9648V4.768H36.0688C34.9808 10.4 34.0528 16.032 33.2208 21.824H33.1568C32.2608 16.032 31.3008 10.4 30.2448 4.768H21.4448V28Z",
  fill: "#0E1F25"
});
var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M21.4448 28H27.0128L26.9168 21.28C26.8848 18.048 26.8208 14.528 26.6288 10.656H26.6928C27.6848 16.512 28.5488 20.896 30.4368 28H35.4608C37.3488 20.896 38.2768 16.512 39.3008 10.656H39.3648C39.1408 14.528 39.1088 17.984 39.0768 21.056L38.9808 28H44.9648V4.768H36.0688C34.9808 10.4 34.0528 16.032 33.2208 21.824H33.1568C32.2608 16.032 31.3008 10.4 30.2448 4.768H21.4448V28Z",
  fill: "url(#paint1_linear_1624_10791)"
});
var _ref6 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint0_linear_1624_10791",
  x1: 24,
  y1: 0,
  x2: 24,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCEDF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1C5FB"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "paint1_linear_1624_10791",
  x1: 24,
  y1: 0,
  x2: 24,
  y2: 32,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#FCEDF7"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "#A1C5FB"
})));
function SvgCareerMinderInitials(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 32,
    viewBox: "0 0 48 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "career-minder-logo",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6);
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCareerMinderInitials);
export default __webpack_public_path__ + "static/media/career-minder-initials.fd12a67c238cb808b790c6c6377fc94a.svg";
export { ForwardRef as ReactComponent };